import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export interface ConfigurationProfilesWebComponentSchema {
  availableCompanies: Array<Target>;
  selectedTarget: Target;
}

export enum RpcExclusionListsMethod {
  ASSIGN_TO_POLICIES = 'assignToMultiplePolicies',
  REMOVE_RECORDS = 'removeRecords',
}

export interface AssignToPoliciesResponse {
  success: boolean;
}

export enum RpcCompanyMethod {
  GET_AVAILABLE_COMPANIES = "getAvailableCompanies"
}

export enum RpcAction {
  EXCLUSION_LISTS = "ExclusionLists",
  COMPANY = "Company"
}
